var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { REPORTS_RECEIVE_SCORES } from 'components/constants';
var initialState = {
    scoreListing: {
        items: []
    }
};
export default (function (state, _a) {
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        default:
            return state;
        case REPORTS_RECEIVE_SCORES:
            return __assign(__assign({}, state), { scoreListing: payload });
    }
});
